import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Project from './Project';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Project />
  </React.StrictMode>
);


